//Reference: EN052

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class Question extends Mappeable {

    idQuestionTypePk: number;
    //CODE: string;
    txtQuestion: string;
    optionQuestion: boolean;
    textQuestion: boolean;
    typeQuestion: any;
    nmrOrder: number;
    dateInsert: string;
    dateUpdate: string;
    userInsert: string;
    userUpdate: string;

    constructor(o) {
        super(o);
        this.typeQuestion = this.optionQuestion === true ? { value: "Elección" } : { value: "Texto" };
        this.optionQuestion = _.isUndefined(this.optionQuestion) || _.isNull(this.optionQuestion) ? false : this.optionQuestion;
        this.textQuestion = _.isUndefined(this.textQuestion) || _.isNull(this.textQuestion) ? false : this.textQuestion;
    }
    /*
        public mapToTable() {
            return {
                idQuestionTypePk: this.idQuestionTypePk,
                isOptionQuestion: this.isOptionQuestion,
                isTextQuestion: this.isTextQuestion,
                txtQuestion: this.txtQuestion,
                typeQuestion: this.typeQuestion
            }
        }
    */
    public mapToBack() {
        return {
            txtQuestion: this.txtQuestion,
            optionQuestion: this.optionQuestion,
            textQuestion: this.textQuestion
        }
    }

    public mapToBackSurveyQuestion() {
        return {
            idQuestionTypePk: this.idQuestionTypePk,
            nmrOrder: this.nmrOrder,
            optionQuestion: this.optionQuestion,
            textQuestion: this.textQuestion,
            txtQuestion: this.txtQuestion
        }
    }
}